"use client"

import { Banner } from "@/app/components/Banner"
import LetUsTalk from "@/app/components/LetUsTalk"
import Location from "@/app/components/Location"
import { useTranslations } from "next-intl"


const ContactUs = () => {
  const  t  = useTranslations()


  return (
    <>
    <Banner
        name={t('links.contactUs')}
        className='bg-contactBanner'
      />
      <main className='my-20 sm:gap-10 grid grid-cols-12 px-6 sm:px-14 md:px-16'>
        <LetUsTalk className='col-span-12 lg:col-span-4' />
        {/* <ContactUsForm className='col-span-12 pt-10 lg:col-span-8 lg:ps-16 lg:pt-0' /> */}
        <div className='col-span-12 h-72 sm:h-full pt-10 lg:col-span-8 lg:ps-16 lg:pt-0'>
          <Location />
        </div>
      </main>
    </>
  )
}

export default ContactUs
